import { render } from "./PaymentReceipt.vue?vue&type=template&id=14d91246&ts=true"
import script from "./PaymentReceipt.vue?vue&type=script&lang=ts"
export * from "./PaymentReceipt.vue?vue&type=script&lang=ts"

import "./PaymentReceipt.vue?vue&type=style&index=0&id=14d91246&lang=scss"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__